class CrusherChip extends HTMLElement {
  static get observedAttributes() {
    return ['color'];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this._render();
  }

  attributeChangedCallback() {
    this._render();
  }

  _accentFor(color) {
    switch (color) {
      case 'secondary':
      case 'info':
        return 'var(--crusher-color-brand-secondary)';
      case 'warning':
        return 'var(--crusher-color-brand-accent-orange)';
      case 'danger':
      case 'error':
        return 'var(--crusher-color-brand-accent-red)';
      case 'neutral':
        return 'var(--crusher-text-secondary)';
      case 'success':
      case 'brand':
      default:
        return 'var(--crusher-color-brand-primary)';
    }
  }

  _render() {
    const color = this.getAttribute('color') || 'brand';
    const accent = this._accentFor(color);

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: inline-block;
        }

        .chip {
          --_chip-accent: ${accent};
          display: inline-flex;
          align-items: var(--crusher-chip-align, center);
          justify-content: var(--crusher-chip-justify, center);
          min-block-size: var(--crusher-chip-min-height, calc(var(--crusher-spacing-4) + var(--crusher-spacing-3)));
          padding-block: var(--crusher-chip-padding-block, var(--crusher-spacing-2));
          padding-inline: var(--crusher-chip-padding-inline, calc(var(--crusher-spacing-3) + var(--crusher-spacing-1) / 2));
          border-radius: var(--crusher-chip-radius, var(--crusher-radius-full));
          border: var(--crusher-chip-border-width, var(--crusher-component-border-weight)) solid var(--crusher-chip-border, color-mix(in srgb, var(--_chip-accent) 22%, var(--crusher-border-primary)));
          background: var(--crusher-chip-bg,
            linear-gradient(180deg, color-mix(in srgb, var(--crusher-color-base-white) 22%, transparent), transparent),
            color-mix(in srgb, var(--_chip-accent) 14%, var(--crusher-background-surface))
          );
          color: var(--crusher-chip-color, color-mix(in srgb, var(--crusher-text-primary) 84%, var(--_chip-accent) 16%));
          font-size: var(--crusher-chip-font-size, var(--crusher-font-size-xs));
          font-weight: var(--crusher-chip-font-weight, var(--crusher-font-weight-semibold));
          letter-spacing: var(--crusher-chip-letter-spacing, 0.01em);
          line-height: var(--crusher-chip-line-height, 1);
          white-space: var(--crusher-chip-white-space, nowrap);
          box-shadow: var(--crusher-chip-shadow, var(--crusher-shadow-1));
          transition:
            background-color var(--crusher-transition-duration-fast),
            border-color var(--crusher-transition-duration-fast),
            color var(--crusher-transition-duration-fast),
            transform var(--crusher-transition-duration-fast),
            box-shadow var(--crusher-transition-duration-fast);
        }

        :host(:hover) .chip {
          background: var(--crusher-chip-hover-bg, color-mix(in srgb, var(--_chip-accent) 18%, var(--crusher-background-surface)));
          transform: var(--crusher-chip-hover-transform, translateY(calc(var(--crusher-component-border-weight) * -1)));
          box-shadow: var(--crusher-chip-hover-shadow, var(--crusher-shadow-2));
        }
      </style>
      <span class="chip" part="base"><slot></slot></span>
    `;
  }
}

customElements.define('crusher-chip', CrusherChip);
